export default function SvgImage() {
  return (
    <>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20px"
      fill="#000"
      viewBox="0 0 30 30"
      >
     <path d="M21.167 12c-.402 0-.76.207-1.02.48l-5.993 6.296c-.26.29-.543.268-.792 0l-2.996-3.25c-.3-.324-.686-.52-1.107-.526-.422-.005-.814.205-1.115.543L3.16 21.136c-.48.48.26 1.21.737.682l4.986-5.593c.355-.41.626-.154.776.018l2.996 3.25c.298.325.686.507 1.102.507.416 0 .8-.187 1.102-.506l5.993-6.297c.31-.317.618-.162.792 0l4.487 4.636c.47.498 1.197-.24.707-.718L22.35 12.48c-.338-.35-.766-.48-1.185-.48zM3.5 24h23a.499.499 0 110 1h-23a.499.499 0 110-1zm5-18C7.125 6 6 7.125 6 8.5S7.125 11 8.5 11 11 9.875 11 8.5 9.875 6 8.5 6zm0 1c.834 0 1.5.666 1.5 1.5S9.334 10 8.5 10 7 9.334 7 8.5 7.666 7 8.5 7zm-7-7C.678 0 0 .678 0 1.5v27c0 .822.678 1.5 1.5 1.5h27c.822 0 1.5-.678 1.5-1.5v-27c0-.822-.678-1.5-1.5-1.5zm0 1h27c.286 0 .5.214.5.5v27c0 .286-.214.5-.5.5h-27a.488.488 0 01-.5-.5v-27c0-.286.214-.5.5-.5z"></path>
   </svg>
  </>
  );
}
